import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "h-full"
};
var _hoisted_2 = {
  class: "go-to-use"
};
var _hoisted_3 = {
  class: "flex justify-center"
};
import { ref, computed, onMounted } from "vue";
import ShareCouponInfo from "@/components/activity/ShareCouponInfo.vue";
import { isLogin, getUserId } from "@/utils/authUtil";
import { assistSharingUserActivity } from "@/api/activity";
import { useRouter } from "@/hooks/useRouter";
import { SHARING_ACTIVITY_ASSISTED } from "@/constant/responseCode";
import { showToast } from "@/utils/toastUtil";
import { useSupplierStore } from "@/store/supplierStore";
import LoopSwipe from "@/components/activity/LoopSwipe.vue";
import Dialog from "@/components/activity/dialog";
import { askPushSubscription } from "@/utils/PushSubscriptionUtil";
import { Login } from "@/components/login/LoginDialog";
import { useI18n } from "vue-i18n";
export default {
  __name: 'SharingAssistor',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var _useRouter = useRouter(),
      routerReplace = _useRouter.routerReplace,
      routerPush = _useRouter.routerPush;
    var activityInfo = ref(window.__ACTIVITY_INFO__);
    var AssistorRewardCoupon = computed(function () {
      return activityInfo.value.assistor_reward_coupon;
    });
    function handleGetCoupon() {
      if (isLogin()) {
        afterLogin();
      } else {
        Login.open({
          onSuccess: function onSuccess() {
            afterLogin();
          }
        });
      }
    }
    function afterLogin() {
      return _afterLogin.apply(this, arguments);
    }
    function _afterLogin() {
      _afterLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(getUserId() === activityInfo.value.sharer_user_id)) {
                _context2.next = 4;
                break;
              }
              routerReplace({
                name: "SharingSharer"
              });
              _context2.next = 8;
              break;
            case 4:
              _context2.next = 6;
              return assistSharingUserActivity({
                activity_id: activityInfo.value.activity_id,
                sharer_user_id: activityInfo.value.sharer_user_id
              });
            case 6:
              res = _context2.sent;
              if (res.isOK) {
                showToast("Success", 1000);
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!supplierStore.getWhatsappid) {
                          _context.next = 4;
                          break;
                        }
                        window.location.href = "https://wa.me/".concat(supplierStore.getWhatsappid, "/?text=").concat(encodeURIComponent(t("wantToUseMyVoucher")));
                        _context.next = 7;
                        break;
                      case 4:
                        _context.next = 6;
                        return askPushSubscription();
                      case 6:
                        routerPush({
                          name: "MyCouponList"
                        });
                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                })), 1000);
              } else if (res.code === SHARING_ACTIVITY_ASSISTED) {
                Dialog.confirm({
                  title: t("alreadyParticipatedInThisActivity"),
                  okText: t("getMoreVouchers"),
                  withoutCancel: true,
                  closeOnClickOverlay: false,
                  onOk: handleGoHome
                });
              } else {
                Dialog.confirm({
                  title: t("theActivityHasEnded"),
                  okText: t("getMoreVouchers"),
                  withoutCancel: true,
                  closeOnClickOverlay: false,
                  onOk: handleGoHome
                });
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _afterLogin.apply(this, arguments);
    }
    function handleGoHome() {
      routerPush({
        name: "Index"
      });
    }
    onMounted(function () {
      if (isLogin() && getUserId() === activityInfo.value.sharer_user_id) {
        routerReplace({
          name: "SharingSharer"
        });
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "activity-sharing-main",
        style: _normalizeStyle({
          'background-image': activityInfo.value.loading_page_background ? "url(".concat(activityInfo.value.loading_page_background, ")") : ''
        })
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(ShareCouponInfo, {
        title: _ctx.$t('getAVoucher', [AssistorRewardCoupon.value.title]),
        "discount-type": AssistorRewardCoupon.value.discount_type,
        "discount-rule": AssistorRewardCoupon.value.discount_rule,
        "button-text": _ctx.$t('getItNow'),
        onClickButton: handleGetCoupon
      }, null, 8, ["title", "discount-type", "discount-rule", "button-text"])])])], 4), _createVNode(LoopSwipe)]);
    };
  }
};